module.exports = __webpack_public_path__ + "static/hut-doodle-f26ae3b1a1eb8b5f975a4492eb641419.jpg";